import ChangeAppointment from "./ChangeAppointment";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import PatientDetails from "../Patients/PatientDetails";
import AppointmentListNew1 from "./AppointmentListNew1";
import NewBill from "../Billing/NewBill";
import WorkItemDetails from "../Worklist/WorkItemDetails";

import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AppointmentDetails from "./AppointmentDetails";
import { Box, Grid2 } from "@mui/material";
import PrescriptionForm from "../Prescriptions/PrescriptionForm";
import { useSnackbar } from "../Utility/UserMessageContext";
import NewVisit from "./NewVisit";
import EditVisit from "./EditVisit";
import PrescriptionReadOnlyView from "../Prescriptions/PrescriptionReadOnlyView";
import NoteTypeDialog from "../Worklist/NoteTypeDialogue";
import PhysiotherapyTreatmentNotes from "../Worklist/PhysioTherapyTreatmentNotes";

import LaparoscopyPrescriptionForm from "../Prescriptions/LaproscopyPrescriptionForm";
import PhysiotherapyPrescriptionForm from "../Prescriptions/PhysiotherapyPrescriptionForm";
import LaboratoryTestReport from "../Prescriptions/LaboratoryTestReport";
import FrozenShoulderPrescriptionForm from "../Prescriptions/FozenShoulderPrescriptionForm";
import { LocalStorageKeys, PrescriptionTypes } from "../Utility/Constants";
import GeneralNote from "../Worklist/GeneralNote";
import MedicalRecord from "../Worklist/MedicalRecord";
import AddServicesToVisit from "./AddServicesToVisit";
import { useDebouncedEffect } from "../Utility/Utility";
import { clearFormDataFromLocal, getFormDataFromLocal } from "../Utility/FormDataTempStorage";
import UnsavedDataConfirmationDialog from "../common/UnsavedDataConfirmationDialog";
import VisitDashboard from "./VisitDashboard";
// import AppointmentTable1 from './AppointmentTable2';
// import './app1.css';

function AppointmentsHome1() {

  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);

  const [newAppointmentTabNumber, setNewAppointmentTabNumber] = useState(-1);
  const { showSnackbar } = useSnackbar();

  const [newNoteTabNumber, setNewNoteTabNumber] = useState(0);
  const [newMedicalRecordTabNumber, setNewMedicalRecordTabNumber] = useState(0);
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);

  //const[newPrescriptionNumber, setNewPrescriptionNumber] = useState(-1);
  const [newPrescriptionTabNumber, setNewPrescriptionTabNumber] = useState(0);
  
  // const [tabs, setTabs] = useState(() => {
  //   const savedTabs = localStorage.getItem(LocalStorageKeys.VisitsTabs);
  //   return savedTabs
  //     ? JSON.parse(savedTabs)
  //     : [
  //         { label: "Visits", value: "Visits", type: "visit-list" },
  //         { label: "Dashboard", value: "Dashboard", type: "dashboard" }
  //       ];
  // });
const [tabs, setTabs] = useState(() => {
  const savedTabs = localStorage.getItem(LocalStorageKeys.VisitsTabs);
  const defaultTabs = [
    { label: "Dashboard", value: "Dashboard", type: "dashboard" },
    { label: "Visits", value: "Visits", type: "visit-list" },
  ];
  if (!savedTabs) return defaultTabs;

  const parsed = JSON.parse(savedTabs);
  const dynamic = parsed.filter(
    (t) => t.value !== "Dashboard" && t.value !== "Visits"
  );
  return [
    { label: "Dashboard", value: "Dashboard", type: "dashboard" },
    { label: "Visits", value: "Visits", type: "visit-list" },
    ...dynamic,
  ];
});
  const [tabHistory, setTabHistory] = useState(() => {
    const saved = localStorage.getItem(LocalStorageKeys.VisitsTabHistory);
    return saved ? JSON.parse(saved) : ["Visits"];
  });

  // Initialize active tab with local storage
  const [activeTab, setActiveTab] = useState(() => {
    const savedActiveTab = localStorage.getItem(
      LocalStorageKeys.VisitsActiveTab,
    );
    return savedActiveTab || "Dashboard";
  });

  useEffect(() => {
    setTabHistory((prev) => {
      // Avoid duplicates in sequence
      if (prev[prev.length - 1] === activeTab) return prev;
      const filtered = prev.filter((t) => t !== activeTab);
      const newHistory = [...filtered, activeTab];
      return newHistory;
    });
  }, [activeTab]);

  useEffect(() => {
    // Save tabs to local storage whenever they change
    //var tabsToBeSaved = tabs.filter((t) => t.type !== "new-visit");
    localStorage.setItem(LocalStorageKeys.VisitsTabs, JSON.stringify(tabs));
  }, [tabs]);

  // Save active tab to local storage whenever it changes
  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.VisitsActiveTab, activeTab);
  }, [activeTab]);

  useDebouncedEffect(
    () => {
      localStorage.setItem(LocalStorageKeys.VisitsTabs, JSON.stringify(tabs));
    },
    [tabs],
    500,
  );

  useDebouncedEffect(
    () => {
      localStorage.setItem(LocalStorageKeys.VisitsActiveTab, activeTab);
    },
    [activeTab],
    500,
  );

  useDebouncedEffect(
    () => {
      localStorage.setItem(
        LocalStorageKeys.VisitsTabHistory,
        JSON.stringify(tabHistory),
      );
    },
    [tabHistory],
    500,
  );

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const closeCurrentTabAndSwitchTab = () => {
    setTabs((prevTabs) => prevTabs.filter((tab) => tab.value !== activeTab));
    setTabHistory((prev) => {
      const filtered = prev.filter((t) => t !== activeTab);
      // Find the last tab in history that still exists in tabs
      const remainingTabs = tabs
        .filter((tab) => tab.value !== activeTab)
        .map((tab) => tab.value);
      const lastActive = [...filtered]
        .reverse()
        .find((t) => remainingTabs.includes(t));
      setActiveTab(lastActive || "Worklist");
      localStorage.setItem(
        LocalStorageKeys.VisitsTabHistory,
        JSON.stringify(filtered),
      );
      return filtered;
    });
  };

  const handleCloseTab = (tabValue) => {
      if (tabValue === "Visits" || tabValue === "Dashboard") return;
      const unsavedData = getFormDataFromLocal(tabValue);
      if(unsavedData) {
        setShowUnsavedChangesDialog(true);
        return;
      }
      closeTab(tabValue);
      
    };
  
    const closeTab = (tabValue) => {
      setTabs((prevTabs) => prevTabs.filter((tab) => tab.value !== tabValue));
      setTabHistory((prev) => {
        const filtered = prev.filter((t) => t !== tabValue);
        // If the closed tab was active, activate the last in history
        if (activeTab === tabValue) {
          const remainingTabs = tabs
            .filter((tab) => tab.value !== tabValue)
            .map((tab) => tab.value);
          const lastActive = [...filtered]
            .reverse()
            .find((t) => remainingTabs.includes(t));
          setActiveTab(lastActive || "Visits");
        }
        localStorage.setItem(
          LocalStorageKeys.MyWorkListTabHistory,
          JSON.stringify(filtered),
        );
        return filtered;
      });
    };

  const handleDiscardChanges = () => {
      clearFormDataFromLocal(activeTab);
      closeTab(activeTab);
      setShowUnsavedChangesDialog(false);
    }

  const handleViewVisitDetails = (visitData) => {
    const existingTab = tabs.find((tab) => tab.value === visitData.id);
    if (existingTab) {
      setActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: visitData?.displayId,
      value: visitData?.id,
      type: "visit-details",
      props: JSON.stringify(visitData),
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab(newTab.value);
  };
  const handleViewDetails = (selectedVisitId, selectedVisitDisplayId) => {
    // Check if the tab is already open - use consistent tab value format
    const existingTab = tabs.find((tab) => tab.value === selectedVisitId);

    if (existingTab) {
      // If the tab exists, switch to it
      setActiveTab(existingTab.value);
    } else {
      // Create a new tab if it doesn't exist
      const newTab = {
        label: selectedVisitDisplayId,
        value: selectedVisitId, // ✅ Use visitId as value (consistent with visit-details tabs)
        type: "visit-details",
        selectedVisitId: selectedVisitId,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setActiveTab(selectedVisitId); // ✅ Switch to the newly added tab using visitId
    }
  };
 const handleAddServices = (visitData) => {
  const existingTab = tabs.find(
    (tab) => tab.value === `AddServices-${visitData.id}`
  );
  if (existingTab) {
    setActiveTab(existingTab.value);
    return;
  }

  const newTab = {
    label: `Add Services - ${visitData.displayId}`,
    value: `AddServices-${visitData.id}`,
    type: "add-services",
    visitData: visitData,
  };

  setTabs((prevTabs) => [...prevTabs, newTab]);
  setActiveTab(newTab.value);
};

  // Add these handlers after handleAddMedicalRecord function
  // Add this function after handleAddMedicalRecord (around line 150)
  const handleEditPrescription = (serviceId, prescriptionDetails) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find(
        (tab) => tab.value === prescriptionDetails.id,
      );

      if (existingTab) {
        setActiveTab(existingTab.value);
        return prevTabs;
      } else {
        const newTab = {
          label: prescriptionDetails?.displayId,
          value: prescriptionDetails?.id,
          type: "EditPrescription",
          serviceId: serviceId,
          prescriptionId: prescriptionDetails?.id,
          prescriptionType: prescriptionDetails.prescriptionType,
        };

        setActiveTab(prescriptionDetails?.id);
        return [...prevTabs, newTab];
      }
    });
  };

  // Add this function after handleEditPrescription
  const handleEditNote = (serviceId, noteDetails) => {
    setTabs((prevTabs) => {
      const existingTab = tabs.find((tab) => tab.value === noteDetails.id);

      if (existingTab) {
        setActiveTab(existingTab.value);
        return prevTabs;
      } else {
        let tabLabel;
        let tabType;

        if (noteDetails.noteType === "General") {
          tabLabel = noteDetails?.displayId || "General Note";
          tabType = "EditGeneralNote";
        } else if (noteDetails.noteType === "PhysiotherapyTreatment") {
          tabLabel = noteDetails?.displayId || "Physio Note";
          tabType = "EditPhysioNote";
        }

        const newTab = {
          label: tabLabel,
          value: noteDetails?.id,
          type: tabType,
          serviceId: serviceId,
          noteId: noteDetails?.id,
        };

        setActiveTab(noteDetails?.id);
        return [...prevTabs, newTab];
      }
    });
  };

  const handleDeletePrescription = (serviceId, prescriptionId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter(
        (tab) => tab.value !== prescriptionId,
      );
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setActiveTab(existingTab.value);
        // If you have ref, add: workItemDetailsRef.current?.refreshPrescriptions();
      } else {
        setActiveTab("Visits");
      }

      return updatedTabs;
    });
  };

  const handleDeleteNote = (serviceId, noteId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter((tab) => tab.value !== noteId);
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setActiveTab(existingTab.value);
      } else {
        setActiveTab("Visits");
      }

      return updatedTabs;
    });
  };

  const handleDeleteMedicalRecord = (serviceId, recordId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter((tab) => tab.value !== recordId);
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setActiveTab(existingTab.value);
      } else {
        setActiveTab("Visits");
      }

      return updatedTabs;
    });
  };

  // Update handleSavePrescription to match VisitsHome
  const handleSavePrescription = (
    serviceId,
    prescriptionId,
    prescriptionStatus,
  ) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find((tab) => tab.value === serviceId);
      if (existingTab) {
        // workItemDetailsRef.current?.refreshPrescriptions();
      }
      return prevTabs; // Keep all tabs as they are
    });
  };

  const handleSaveNote = (serviceId, noteId, noteStatus) => {
    setTabs((prevTabs) => {
      if (noteStatus === "Final") {
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          // workItemDetailsRef.current?.refreshClinicalNotes();
        }
        return prevTabs;
      } else {
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          // workItemDetailsRef.current?.refreshClinicalNotes();
        }
        return prevTabs;
      }
    });
  };

  const handleSaveMedicalRecord = (serviceId, recordId, recordStatus) => {
    setTabs((prevTabs) => {
      if (recordStatus === "Final") {
        const updatedTabs = prevTabs.filter((tab) => tab.value !== recordId);
        const existingTab = updatedTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          setActiveTab(existingTab.value);
          // workItemDetailsRef.current?.refreshMedicalRecords();
        } else {
          setActiveTab("Visits");
        }
        return updatedTabs;
      } else {
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          // workItemDetailsRef.current?.refreshMedicalRecords();
        }
        return prevTabs;
      }
    });
  };
  const openPrescriptionViewTab = (
    prescriptionId,
    prescriptionDisplayId,
    prescriptionType,
  ) => {
    setTabs((prevTabs) => {
      const existingTab = tabs.find((tab) => tab.value === prescriptionId);
      if (existingTab) {
        setActiveTab(existingTab.value);
      } else {
        const newTab = {
          label: prescriptionDisplayId || "Prescription",
          value: prescriptionId,
          type: "ViewPrescription",
          prescriptionId: prescriptionId,
          prescriptionType: prescriptionType,
        };

        setActiveTab(prescriptionId);
        return [...prevTabs, newTab];
      }
      return prevTabs;
    });
  };

  const openBillTab = (billData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `EditBill-${billData.id}`,
    );
    if (existingTab) {
      setActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `Edit Bill - ${billData.patientName}`,
      value: `EditBill-${billData.id}`,
      type: "edit-bill",
      billData: billData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab(newTab.value);
  };
  const handleViewPatientDetails = (patientData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `PatientDetails-${patientData.id}`,
    );
    if (existingTab) {
      setActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `${patientData.firstName} ${patientData.lastName}`,
      value: `PatientDetails-${patientData.id}`,
      type: "patient-details",
      patientData: patientData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab(newTab.value);
  };
  const handleNewPrescription = (appointmentId) => {
    const newTabNumber = newPrescriptionTabNumber + 1;
    setNewPrescriptionTabNumber(newTabNumber);

    //const existingTab = tabs.find((ta b) => tab.value === "NewAppointment");

    // if (existingTab) {
    //   // If the tab exists, switch to it
    //   setActiveTab(existingTab.value);
    // } else {
    //Create a new tab if it doesn't exist
    //const newTabValue = tabs.length + 1; // Assign a unique value for the new tab
    const newTab = {
      label:
        newTabNumber === 0
          ? "New Prescription"
          : "New Prescription (" + newTabNumber + ")",
      value: "NewPrescription" + newTabNumber,
      content: (
        <PrescriptionForm
          key={newTabNumber}
          appointmentId={appointmentId}
          mode="new"
        />
      ),
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab("NewPrescription" + newTabNumber); // Switch to the newly added tab
  };
  const handleAddNewPrescription = (
    serviceId,
    prescriptionType = "GeneralPrescription",
  ) => {
    setNewPrescriptionTabNumber((prevTabNumber) => {
      const newTabNumber = prevTabNumber + 1;

      let tabLabel;
      if (prescriptionType === "PathologyLabReport") {
        tabLabel =
          newTabNumber === 1
            ? "New Lab Report"
            : `New Lab Report ${newTabNumber}`;
      } else if (prescriptionType === "PhysiotherapyPrescription") {
        tabLabel =
          newTabNumber === 1
            ? "New Physio Prescription"
            : `New Physio Prescription ${newTabNumber}`;
      } else if (
        prescriptionType === "FrozenShoulder" ||
        prescriptionType === PrescriptionTypes.FrozenShoulder
      ) {
        tabLabel =
          newTabNumber === 1
            ? "New Frozen Shoulder"
            : `New Frozen Shoulder ${newTabNumber}`;
      } else {
        tabLabel =
          newTabNumber === 1
            ? "New Prescription"
            : `New Prescription ${newTabNumber}`;
      }

      const newTab = {
        label: tabLabel,
        value: `NewPrescription-${prescriptionType}-${newTabNumber}`,
        type: "new-prescription",
        serviceId: serviceId,
        prescriptionType: prescriptionType,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setActiveTab(`NewPrescription-${prescriptionType}-${newTabNumber}`);

      return newTabNumber;
    });
  };
  const handleAddNote = useCallback((serviceId) => {
    setSelectedServiceId(serviceId);
    setNoteDialogOpen(true);
  }, []);

  const handleNoteTypeSelect = (noteType) => {
    setNewNoteTabNumber((prevTabNumber) => {
      const newTabNumber = prevTabNumber + 1;

      let tabLabel;
      let tabType;

      switch (noteType) {
        case "General":
          tabLabel =
            newTabNumber === 1
              ? "General Notes"
              : `General Notes ${newTabNumber}`;
          tabType = "AddGeneralNote";
          break;
        case "Physiotherapy":
          tabLabel =
            newTabNumber === 1
              ? "Physio Notes"
              : `Physio Notes ${newTabNumber}`;
          tabType = "AddPhysioNote";
          break;
        default:
          tabLabel = "Notes";
          tabType = "AddGeneralNote";
      }

      const newTab = {
        label: tabLabel,
        value: `AddNote-${noteType}-${newTabNumber}`,
        type: tabType,
        serviceId: selectedServiceId,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setActiveTab(`AddNote-${noteType}-${newTabNumber}`);

      return newTabNumber;
    });
    setNoteDialogOpen(false);
  };

  const handleAddMedicalRecord = (serviceId) => {
    setNewMedicalRecordTabNumber((prevTabNumber) => {
      const newTabNumber = prevTabNumber + 1;

      const newTab = {
        label:
          newTabNumber === 1
            ? "New Medical Record"
            : `New Medical Record ${newTabNumber}`,
        value: `NewMedicalRecord-${newTabNumber}`,
        type: "new-medical-record",
        serviceId: serviceId,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setActiveTab(`NewMedicalRecord-${newTabNumber}`);

      return newTabNumber;
    });
  };

  const handleNewAppointment = (visitType) => {
    // Check if the tab is already open
    var newTabNumber = 0;
    var newTabValue = "NewVisit" + newTabNumber;
    while (tabs.find((tab) => tab.value === newTabValue)) {
      newTabNumber++;
      newTabValue = "NewVisit" + newTabNumber;
    }

    setNewAppointmentTabNumber(newTabNumber);

    //const existingTab = tabs.find((tab) => tab.value === "NewAppointment");

    // if (existingTab) {
    //   // If the tab exists, switch to it
    //   setActiveTab(existingTab.value);
    // } else {
    //Create a new tab if it doesn't exist
    //const newTabValue = tabs.length + 1; // Assign a unique value for the new tab
    const newTab = {
      label:
        newTabNumber === 0
          ? `New Visit (${visitType})`
          : `New Visit (${visitType}) (${newTabNumber})`,
      value: "NewVisit" + newTabNumber,
      type: "new-visit",
      props: { visitType: visitType },
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab("NewVisit" + newTabNumber); // Switch to the newly added tab
  };
  const handleViewWorklistDetails = (worklistData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `WorklistDetails-${worklistData.id}`,
    );
    if (existingTab) {
      setActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `Worklist - ${worklistData.displayId}`,
      value: `WorklistDetails-${worklistData.id}`,
      type: "worklist-details",
      worklistData: worklistData,
      viewMode: worklistData.viewMode ?? "default", 
       
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab(newTab.value);
  };

  const handleEditVisit = (visit) => {
    const newTab = {
      label: `Edit (${visit?.displayId})`,
      value: "EditVisit" + visit?.id,
      visit: visit,
      type: "edit-visit",
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setActiveTab(newTab.value); // Switch to the newly added tab
  };

  return (
    <>
    <Grid2 container>
      <NoteTypeDialog
        open={noteDialogOpen}
        onClose={() => setNoteDialogOpen(false)}
        onSelect={handleNoteTypeSelect}
      />
      <TabContext value={activeTab}>
        <Grid2
          container
          size={12}
          alignItems="center"
          spacing={1}
          sx={{ borderBottom: "1px solid lightgray", width: "100%" }}
        >
          <Tabs value={activeTab} onChange={handleChange} variant="scrollable">
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={
                  <Box>
                    {tab.label}
                    {tab.value !== "Visits" && tab.value !== "Dashboard" && ( // Show close button only for dynamic tabs
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering tab change
                          handleCloseTab(tab.value);
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                }
                value={tab.value}
              />
            ))}
          </Tabs>
        </Grid2>

        {tabs.map((tab) => (
          <TabPanel
            key={tab.value}
            value={tab.value}
            sx={{ padding: "0px", width: "100%" }}
            // keepMounted={tab.value !== "Visits"}
            keepMounted={tab.value !== "Visits" || tab.value === "Dashboard"}
          >
            {tab.type === "visit-list" && (
              <AppointmentListNew1
                onViewDetails={handleViewDetails}
                onAddNewAppointment={handleNewAppointment}
                onAddNewPrescription={handleNewPrescription}
                onViewPatientDetails={handleViewPatientDetails}
                onEditVisit={handleEditVisit}
                onViewDocument={openPrescriptionViewTab}
              />
            )}

            {tab.type === "dashboard" && (
              <VisitDashboard
                key={tab?.value}
                closeTab={handleCloseTab}
              />
            )}

            {/* {tab.value !== "Visits" && tab.content} */}
            {/* {tab.type === "visit-details" && <AppointmentDetails key={tab?.value} selectedAppointment = {tab?.props && JSON.parse(tab?.props)}/>} */}
            {tab.type === "visit-details" && (
              <AppointmentDetails
                key={tab?.value}
                selectedVisitId={tab?.selectedVisitId}
                onEditBill={openBillTab}
                onViewPatientDetails={handleViewPatientDetails}
                onViewWorklistDetails={handleViewWorklistDetails}
                onViewDocument={openPrescriptionViewTab} // ✅ Changed from onViewPrescription
                onViewPrescription={openPrescriptionViewTab}
                onEditVisit={handleEditVisit}
                onAddServices={handleAddServices}
              />
            )}
            {tab.type === "new-visit" && (
              <NewVisit
                key={tab?.value}
                newAppointmentTempId={tab?.value}
                visitType={tab?.props?.visitType}
                closeTab={handleCloseTab}
              />
            )}
            {tab.type === "edit-visit" && (
              <EditVisit
                key={tab?.value}
                visit={tab?.visit}
                closeTab={handleCloseTab}
              />
            )}
            {tab.type === "edit-bill" && (
              <NewBill
                key={tab?.value}
                billId={tab?.billData?.id}
                closeTab={handleCloseTab}
              />
            )}
            {tab.type === "patient-details" && (
              <PatientDetails
                key={tab?.value}
                patientId={tab?.patientData?.id}
                closeTab={handleCloseTab}
                onViewDocument={openPrescriptionViewTab}
              />
            )}
            {/* Lab Report - NEW */}
            {tab.type === "new-prescription" &&
              (tab.prescriptionType === "PathologyLabReport" ||
                tab.prescriptionType ===
                  PrescriptionTypes.PathologyLabReport) && (
                <LaboratoryTestReport
                  key={tab?.value}
                  serviceId={tab?.serviceId}
                  mode="new"
                  onSavePrescription={handleSavePrescription}
                  onRemovePrescription={handleDeletePrescription}
                />
              )}

            {/* Physio Prescription */}
            {tab.type === "new-prescription" &&
              tab.prescriptionType === "PhysiotherapyPrescription" && (
                <PhysiotherapyPrescriptionForm
                  key={tab?.value}
                  serviceId={tab?.serviceId}
                  mode="new"
                  onSavePrescription={handleSavePrescription}
                />
              )}

            {/* Frozen Shoulder */}
            {tab.type === "new-prescription" &&
              (tab.prescriptionType === "FrozenShoulder" ||
                tab.prescriptionType === PrescriptionTypes.FrozenShoulder) && (
                <FrozenShoulderPrescriptionForm
                  key={tab?.value}
                  serviceId={tab?.serviceId}
                  mode="new"
                  onSavePrescription={handleSavePrescription}
                  onRemovePrescription={handleDeletePrescription}
                />
              )}

            {/* General Prescription */}
            {tab.type === "new-prescription" &&
              tab.prescriptionType === "GeneralPrescription" && (
                <LaparoscopyPrescriptionForm
                  key={tab?.value}
                  serviceId={tab?.serviceId}
                  mode="new"
                  onSavePrescription={handleSavePrescription}
                />
              )}

            {/* General Note */}
            {tab.type === "AddGeneralNote" && (
              <GeneralNote
                key={tab?.value}
                serviceId={tab?.serviceId}
                onSaveNote={handleSaveNote}
                onRemoveNote={handleDeleteNote}
              />
            )}

            {/* Physio Note */}
            {tab.type === "AddPhysioNote" && (
              <PhysiotherapyTreatmentNotes
                key={tab?.value}
                serviceId={tab?.serviceId}
                onSaveNote={handleSaveNote}
                onRemoveNote={handleDeleteNote}
              />
            )}

            {/* Medical Record */}
            {tab.type === "new-medical-record" && (
              <MedicalRecord
                key={tab?.value}
                availedServiceId={tab?.serviceId}
                onSaveMedicalRecord={handleSaveMedicalRecord}
                onRemoveMedicalRecord={handleDeleteMedicalRecord}
              />
            )}
           {tab.type === "add-services" && (
  <AddServicesToVisit
    key={tab?.value}
    visitId={tab?.visitData?.id}
    visitDisplayId={tab?.visitData?.displayId}
    closeTab={handleCloseTab}
    onViewPatientDetails={handleViewPatientDetails}
    onEditBill={openBillTab}
  />
)}
            {tab.type === "worklist-details" && (
              <WorkItemDetails
                key={tab?.value}
                serviceId={tab?.worklistData?.id}
                viewMode={tab?.viewMode ?? "default"} 
                onViewPatientDetails={handleViewPatientDetails}
                onViewVisitDetails={handleViewDetails}
                onViewPrescription={openPrescriptionViewTab} // Keep this
                onEditPrescription={handleEditPrescription} // ADD THIS LINE - was missing
                onAddNewPrescription={handleAddNewPrescription}
                onAddNote={handleAddNote}
                  
                onViewNote={handleEditNote} // ADD THIS LINE - was missing
                onAddMedicalRecord={handleAddMedicalRecord}
                closeTab={handleCloseTab}
              />
            )}
            {/* Edit Prescription - Lab Report */}
            {tab.type === "EditPrescription" &&
              tab.prescriptionType === PrescriptionTypes.PathologyLabReport && (
                <LaboratoryTestReport
                  key={tab.prescriptionId}
                  serviceId={tab?.serviceId}
                  prescriptionId={tab?.prescriptionId}
                  onSavePrescription={handleSavePrescription}
                  onRemovePrescription={handleDeletePrescription}
                />
              )}

            {/* Edit Prescription - Physiotherapy */}
            {tab.type === "EditPrescription" &&
              tab.prescriptionType ===
                PrescriptionTypes.PhysiotherapyPrescription && (
                <PhysiotherapyPrescriptionForm
                  key={tab.prescriptionId}
                  serviceId={tab?.serviceId}
                  prescriptionId={tab?.prescriptionId}
                  onRemovePrescription={handleDeletePrescription}
                  onSavePrescription={handleSavePrescription}
                />
              )}

            {/* Edit Prescription - General */}
            {tab.type === "EditPrescription" &&
              tab.prescriptionType ===
                PrescriptionTypes.GeneralPrescription && (
                <LaparoscopyPrescriptionForm
                  key={tab.prescriptionId}
                  serviceId={tab?.serviceId}
                  prescriptionId={tab?.prescriptionId}
                  onRemovePrescription={handleDeletePrescription}
                  onSavePrescription={handleSavePrescription}
                />
              )}

            {/* Edit Prescription - Frozen Shoulder */}
            {tab.type === "EditPrescription" &&
              tab.prescriptionType === PrescriptionTypes.FrozenShoulder && (
                <FrozenShoulderPrescriptionForm
                  key={tab.prescriptionId}
                  serviceId={tab?.serviceId}
                  prescriptionId={tab?.prescriptionId}
                  onRemovePrescription={handleDeletePrescription}
                  onSavePrescription={handleSavePrescription}
                />
              )}

            {/* Edit General Note */}
            {tab.type === "EditGeneralNote" && (
              <GeneralNote
                key={tab.noteId}
                serviceId={tab?.serviceId}
                noteId={tab?.noteId}
                onSaveNote={handleSaveNote}
                onRemoveNote={handleDeleteNote}
              />
            )}

            {/* Edit Physio Note */}
            {tab.type === "EditPhysioNote" && (
              <PhysiotherapyTreatmentNotes
                key={tab.noteId}
                serviceId={tab?.serviceId}
                noteId={tab?.noteId}
                onSaveNote={handleSaveNote}
                onRemoveNote={handleDeleteNote}
              />
            )}

            {/* View Prescription - Read Only */}
            {tab.type === "ViewPrescription" && (
              <PrescriptionReadOnlyView
                key={tab.prescriptionId}
                prescriptionId={tab.prescriptionId}
                prescriptionType={tab.prescriptionType}
              />
            )}
          </TabPanel>
        ))}
      </TabContext>
    </Grid2>
    <UnsavedDataConfirmationDialog
      key= {activeTab} // Ensure the dialog resets when activeTab changes
      open={showUnsavedChangesDialog}
      onClose={() => setShowUnsavedChangesDialog(false)}
      onDiscardChanges={handleDiscardChanges}
      title="Unsaved Changes?"
      message="You have unsaved changes. Are you sure you want to discard them?"
      discardButtonText="Discard Changes"
      cancelButtonText="Keep Changes"
    />
    </>
  );
}

export default AppointmentsHome1;
